import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../lib/gtag";

/**
 * Fires a Google Ads page_view event on every SPA route + language change.
 * Also re-runs gtag config so the AW-... id stays associated with the new URL.
 */
export default function GoogleAdsPageTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Defer one tick so document.title reflects the new page
    const id = setTimeout(() => trackPageView(pathname + (search || "")), 60);
    return () => clearTimeout(id);
  }, [pathname, search]);
  return null;
}
